
module.exports = function getResource(label, vars = []) {
    let resources = {
        close: 'Close',
        view: 'View'
    };
    return resources[label];
};
